/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import PostImage from 'app/components/common/PostImage.jsx';
import PostSource from 'app/components/common/PostSource.jsx';
import PostContentSummary from 'app/components/common/PostContentSummary.jsx';
import PostContentLink from 'app/components/common/PostContentLink.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';

class CurateListItemComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hoverItem: null
        };

        this.itemRowMouseOver = this.itemRowMouseOver.bind(this);
        this.itemRowMouseOut = this.itemRowMouseOut.bind(this);

    }

    itemRowMouseOver(elem) {

        this.setState({
            hoverItem: elem
        });

    }

    itemRowMouseOut() {

        this.setState({
            hoverItem: null
        });

    }

    render() {

        let referenceDate = null,
            item = null,
            input = null,
            inputImg = null,
            inputImgSrc = null,
            summaryString = null,
            shareButton = null,
            InputIcon = null,
            summary = null,
            itemDate = null,
            ret = null,
            image = null;

        item = this.props.item;
        referenceDate = null;

        input = _.find(this.props.inputs, (input) => {
            return input.id == this.props.item.iID
        });

        if (!input) {
            return null;
        }

        itemDate = new Date(item.enqueueTs);

        if (!item.item) {
            return null;
        }

        image = (
            <PostImage {...this.props} item={item} src={item.item.photoUrl}/>
        );

        return (
            <div className="curate-item-row item-row" id={item.id} onMouseOver={this.itemRowMouseOver.bind(this, item.id)} onMouseLeave={this.itemRowMouseOut}>
                <div className="item">
                    <Breakpoint mobile only>
                        <div className="mobile-source">
                            <PostSource {...this.props} input={input} date={itemDate}/>
                        </div>
                        <div className="item-image curate-item-image">
                            <PostContentLink content={image} item={item.item}/>
                        </div>
                    </Breakpoint>
                    <Breakpoint desktop only>
                        <div className="item-image curate-item-image">
                            {image}
                        </div>
                        <div className="item-share curate-item-share item-share-full">
                            <div className="btn-item-share" onClick={this.props.shareMethod} data-itemid={item.id} role="button" aria-label="share">
                                <span>Share</span>
                                <i className="fa fa-share fa-lg"></i>
                            </div>
                        </div>
                        <div className="item-share curate-item-share item-share-compact">
                            <span className="fa-stack fa-lg">
                                <i className="fa fa-square-o fa-stack-2x"></i>
                                <i className="fa fa-share fa-stack-1x"></i>
                            </span>
                        </div>
                    </Breakpoint>
                    <div className="item-details curate-item-details curate-list">
                        <PostContentSummary {...this.props} item={item} input={input}/>
                        <Breakpoint desktop only>
                            <PostSource {...this.props} input={input} date={itemDate}/>
                        </Breakpoint>
                    </div>
                    <Breakpoint desktop only>
                        <div className="item-close" onClick={this.props.removeMethod} data-itemid={item.id} role="button" aria-label="remove">
                            <i className="fa fa-times-circle-o"></i>
                        </div>
                    </Breakpoint>
                    <Breakpoint mobile only>
                        <div className="mobile-controls">
                            <div className="mobile-control" onClick={this.props.removeMethod} data-itemid={item.id} role="button" aria-label="remove">
                                <i className="icon ion-ios-trash-outline"></i>
                            </div>
                            <div className="mobile-control" onClick={this.props.shareMethod} data-itemid={item.id} role="button" aria-label="share">
                                <i className="icon ion-share"></i>
                            </div>
                        </div>
                    </Breakpoint>
                </div>
            </div>
        );

    }
};

CurateListItemComponent.propTypes = {
    item: PropTypes.object,
    inputs: PropTypes.array,
    shareMethod: PropTypes.func,
    removeMethod: PropTypes.func
};

CurateListItemComponent.defaultProps = {
    item: {},
    inputs: [],
    shareMethod: () => {},
    removeMethod: () => {}
};

export default CurateListItemComponent;
